

















import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { StripeUpcomingInvoice } from '../../../api/v2/models/subscription'
import DialogDeleteSubscriptionConfirm from '../atoms_molecules/DialogDeleteSubscriptionConfirm.vue'
import { format } from 'date-fns'

@Component({
  components: {
    DialogDeleteSubscriptionConfirm
  }
})
export default class StripeUpcomingInvoiceComponent extends Vue {
  @Prop({ required: true })
  stripeUpcomingInvoice: StripeUpcomingInvoice

  get date() {
    return format(this.stripeUpcomingInvoice.nextPaymentAttempt, 'YYYY/MM/DD')
  }

  cancelSubscription(message = '') {
    this.$emit('cancel', message)
  }

  calculateAmountDue() {
    let amountDue = this.stripeUpcomingInvoice.amountDue
    const lines = this.stripeUpcomingInvoice.lines
    const totalCount = lines.data.length
    let membershipFee = 0
    if (totalCount > 1) {
      membershipFee = lines.data.find(line => line.description?.includes('Membership Fee'))?.amount || 0
    }

    if (membershipFee > 0) {
      return amountDue - membershipFee
    }
    return amountDue
  }
}
